import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-moreHorizontal.icon",
  "use": "besidaMob-moreHorizontal.icon-usage",
  "viewBox": "0 0 408 408",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 408 408\" id=\"besidaMob-moreHorizontal.icon\"><path d=\"M51 153c-28.05 0-51 22.95-51 51s22.95 51 51 51 51-22.95 51-51-22.95-51-51-51zm306 0c-28.05 0-51 22.95-51 51s22.95 51 51 51 51-22.95 51-51-22.95-51-51-51zm-153 0c-28.05 0-51 22.95-51 51s22.95 51 51 51 51-22.95 51-51-22.95-51-51-51z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol